import MainService from './main'
import UserService from './user'
import ProductService from './product'
import CartService from './cart'
import CardService from './card'
import FormService from './form'
import LocationService from './location'

export default {
  MainService,
  UserService,
  ProductService,
  CartService,
  CardService,
  FormService,
  LocationService
}

